module.exports = "<a class=\"dropdown-toggle\" (click)=\"logout()\">Log Out</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/headerandnavigation/login/identitylogout.component.html
// module id = ./src/app/headerandnavigation/login/identitylogout.component.html
// module chunks = main